<template>
  <div class="home">
    <guest-header />

    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="card mt-4">
              <h4>Get a free quote</h4>
              <hr>
              <quote />
            </div>
          </div>
          <div class="col-md-6">
            <div class="info">
              <h4>We are Sidian Credible</h4>
              <p>Your one stop shop for all your bid securities.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <guest-footer />
  </div>
</template>

<script>
	import Quote from "@/components/Guest/QuoteCustom.vue";
    import GuestHeader from "@/components/Guest/Header.vue";
    import GuestFooter from "@/components/Guest/Footer.vue";

	export default {
		components: {
			Quote, GuestHeader, GuestFooter
		},
	}
</script>

<style lang="scss">
@import "../styles/main";
</style>

